import type { AssetStoryblok } from '@/storyblok/component-types-sb'
import { ASSET_TYPE_IMAGE, ASSET_TYPE_VIDEO, ACCEPTED_IMAGE_EXTENSIONS } from '@/utils/constants/media'
import { getStoryblokImageURL } from '@/utils/storyblok/assetsHelper'
import { optionalString } from '@/utils/storyblok/normalizers'

export function useStoryblokAssetData() {
  const nuxtImage = useImage()

  function getFileExtension(asset?: AssetStoryblok) {
    return asset?.filename?.split('.').pop()?.toLowerCase() ?? ''
  }

  function isImage(asset?: AssetStoryblok) {
    return asset?.content_type || ACCEPTED_IMAGE_EXTENSIONS.includes(getFileExtension(asset))
  }

  function getAssetData(asset?: AssetStoryblok, height?: number) {
    if (isImage(asset)) {
      return {
        ...asset,
        height,
        src: getStoryblokImageURL(asset?.filename ?? '', {
          height,
          focusPoint: optionalString(asset?.focus)
        }),
        assetType: ASSET_TYPE_IMAGE,
        isImage: true
      }
    }

    return {
      ...asset,
      height,
      src: nuxtImage(asset?.filename ?? '') ?? '',
      assetType: ASSET_TYPE_VIDEO,
      isImage: false
    }
  }

  return {
    isImage,
    getFileExtension,
    getAssetData
  }
}
